import { Component, OnInit } from "@angular/core";
import { TemplateRulesService } from "../template-rules.service";
import { ListValueService } from "src/app/core/services/list-value.service";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { TokenService } from "src/app/core/services/token.service";
import { TableConstants } from "src/app/constants/tableConstants";
import { RoutingConstants } from "src/app/constants/routingConstants";
import { FiltersTableStateService } from "src/app/core/services/filters-table-state.service";
import { TranslateService } from "@ngx-translate/core";
import { ScreenConstants } from "src/app/constants/screenId.constants";
import { PKTemplateRule } from "../models/template-rules.model";

@Component({
  selector: "app-list-templates-rules",
  templateUrl: "./list-templates-rules.component.html",
  styleUrls: ["./list-templates-rules.component.scss"],
})
export class ListTemplatesRulesComponent implements OnInit {
  typeOfDocumentSelected: string = "0";
  typeOfDocumentObject: {
    tipoCertificado;
    tipoReforma;
    descripcion;
  };
  idTypeDocument: string;
  typeOfDocumentList: [];
  documentList: any = [];
  numPages: number = 0;
  numElements: number = 0;
  totalElements: number = 0;
  tableList = TableConstants.rulesTemplates;
  routing = RoutingConstants.rulesTemplatesRouting;
  options = TableConstants.notShowedFiltersButton;
  filtersTableJSON;
  filtersTable: string;

  constructor(
    private templateRulesService: TemplateRulesService,
    private toastrAlertService: ToastrAlertService,
    private filtersTableStateService: FiltersTableStateService,
    private listValueService: ListValueService,
    private translateService: TranslateService,
    private tokenService: TokenService
  ) {
    this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
      "reIndice",
      ScreenConstants.admSistemas.templateRules
    );
    this.filtersTable = this.filtersTableStateService.getString(
      this.filtersTableJSON
    );
  }

  ngOnInit(): void {
    this.getTypesOfDocument();
    this.typeOfDocumentObject =
      this.templateRulesService.getTypeOfDocumentSelected();
    if (this.typeOfDocumentObject.tipoCertificado !== "0") {
      this.typeOfDocumentSelected =
        this.typeOfDocumentSelectedConvertToString();
      this.loadData(true);
    }
  }

  getTypesOfDocument(): void {
    this.listValueService.listaTipoDeDocumento().subscribe(
      (data) => {
        this.typeOfDocumentList = data;
        if (data && data.length == 0) {
          let message = this.translateService.instant(
            "messages.documentNotFound"
          );
          this.toastrAlertService.toastrWarning(message);
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  loadData(init?: boolean) {
    if (init) {
      this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
        "reIndice",
        ScreenConstants.admSistemas.templateRules
      );
      this.filtersTable = this.filtersTableStateService.getString(
        this.filtersTableJSON
      );
    }
    this.typeOfDocumentSelectedConvertToObject();
    this.templateRulesService.setTypeOfDocumentSelected(
      this.typeOfDocumentObject
    );
    this.templateRulesService
      .listaReglasPlantilla(this.filtersTable, this.typeOfDocumentObject)
      .subscribe(
        (data) => {
          this.documentList = this.mapDataToTable(data["content"]);
          this.numPages = data["totalPages"] == 0 ? 1 : data["totalPages"];
          this.numElements = data["numberOfElements"];
          this.totalElements = data["totalElements"];
          if (data["content"] && data["content"].length == 0) {
            let message = this.translateService.instant(
              "messages.notFoundResutls"
            );
            this.toastrAlertService.toastrWarning(message);
            this.numPages = 1;
          }
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  typeOfDocumentSelectedConvertToObject() {
    let values = this.typeOfDocumentSelected.split("-");
    this.typeOfDocumentObject = {
      tipoCertificado: values[0],
      tipoReforma: values[1],
      descripcion: values[2],
    };
  }
  typeOfDocumentSelectedConvertToString() {
    return (
      this.typeOfDocumentObject.tipoCertificado +
      "-" +
      this.typeOfDocumentObject.tipoReforma +
      "-" +
      this.typeOfDocumentObject.descripcion
    );
  }

  mapDataToTable(data) {
    data.forEach((element) => {
      (element["reIndice"] = element["id"]["reIndice"]),
        (element["reMarcolegal"] = element["id"]["reMarcolegal"]),
        (element["reReforma"] = element["id"]["reReforma"]),
        (element["reTcertificado"] = element["id"]["reTcertificado"]);
    });
    return data;
  }

  filterTable(value: any) {
    this.filtersTableJSON = value.filterTableJSON;
    this.filtersTable = value.filterTableString;
    this.loadData(false);
  }
  moveUpDown(value: any) {
    let move = value.move;
    this.templateRulesService.moveUpDown(move, value.id).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data["mensaje"]);
        this.loadData();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  removeElements(ids: PKTemplateRule[]) {
    let templatesRules: PKTemplateRule[] = [];
    ids.forEach((id) => {
      let element = this.documentList.find(
        (e) =>
          e.reIndice == id.reIndice &&
          e.reMarcolegal == id.reMarcolegal &&
          e.reReforma == id.reReforma &&
          e.reTcertificado == id.reTcertificado
      );
      templatesRules.push(element.id);
    });

    this.templateRulesService.removeRuleTemplate(templatesRules).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data["mensaje"]);
        this.filtersTableJSON = this.filtersTableStateService.initFiltersTable(
          "reIndice",
          ScreenConstants.admSistemas.templateRules
        );
        this.filtersTable = this.filtersTableStateService.getString(
          this.filtersTableJSON
        );
        this.loadData();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }
  goPredefinedMailBox() {
    this.tokenService.redirectPredefinedMailBox();
  }
}
